export default "__VITE_ASSET__e2252d38__"